import { Filter } from 'schemas/FilterSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { DashboardWidgetType } from 'features/dashboard/types'
import { SearchFilterComposingStrategy } from '../searchFilterComposingStrategy'
import { DecoratedSearchFilterComposingStrategy } from './type'

const pivotThemeDecorator = (
  strategy: SearchFilterComposingStrategy
): DecoratedSearchFilterComposingStrategy => ({
  composeDetailSearchFilter: (
    filter: Filter,
    insights: InsightData[],
    pivots: InsightData[],
    widgetSetting?: DashboardWidgetType
  ) => {
    const alteredFilter =
      insights.length > 0
        ? strategy.composeDetailSearchFilter(filter, insights, widgetSetting)
        : filter

    return {
      ...alteredFilter,
      themeIds: [...(alteredFilter.themeIds || []), pivots.map((pivot) => parseInt(pivot.id!, 10))]
    }
  }
})

export default pivotThemeDecorator
